import React from "react";
import "components/General/Form/Form.css";

const Input = (props) => {
  return (
    <input
      className="form-control input-main"
      style={{
        width: props.width,
        marginBottom: props.marginBottom,
        clear: props.clear,
      }}
      id={props.name}
      name={props.name}
      type={props.inputType}
      value={props.value}
      onChange={props.handleChange}
      placeholder={props.placeholder}
      autoComplete={props.autoComplete}
    />
  );
};

export default Input;
